import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import "./App.css";

const logo_url = process.env.REACT_APP_PROVIDER_LOGO_URL           || "";
const logo_alt_text = process.env.REACT_APP_PROVIDER_LOGO_ALT_TEXT || "Site Logo";

const cart_li_01_value = (process.env.REACT_APP_CART_LI_01_VALUE   || "1534") / 100.0;
const cart_li_01_name = process.env.REACT_APP_CART_LI_01_NAME      || "Ordered Item";
// const cart_li_01_qty = process.env.REACT_APP_CART_LI_01_QTY        || "1";

const stripe_pubkey = process.env.REACT_APP_STRIPE_API_PUBLIC_KEY  || "Stripe Public Key NOT INITIALIZED"


// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(stripe_pubkey);

const ProductDisplay = ({ handleClick }) => (
  <section>
    <div className="product" style={{textAlign: 'center'}}>
      <img src={ logo_url } alt={ logo_alt_text } />
      <div className="description">
        <h3>  { cart_li_01_name  }</h3>
        <h5>$ { cart_li_01_value.toFixed(2) }</h5>
      </div>
    </div>
    <button type="button" id="checkout-button" role="link" onClick={handleClick}>
      Checkout
    </button>
  </section>
);

const Message = ({ message }) => (
  <section>
    <p>{message}</p>
  </section>
);

export default function App() {
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage("Rental Application Fee submitted! You will receive an email confirmation.");
    }

    if (query.get("canceled")) {
      setMessage(
        "Rental Application Fee canceled. Continue to look around and submit when you're ready."
      );
    }
  }, []);

  const handleClick = async (event) => {
    const stripe = await stripePromise;

    const response = await fetch("/create-checkout-session", {
      method: "POST",
    });

    const session = await response.json();

    // When the customer clicks on the button, redirect them to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
    }
  };

  return message ? (
    <Message message={message} />
  ) : (
    <ProductDisplay handleClick={handleClick} />
  );
}
